export const OrganizationalUnitsTreeName = 'OrganizationalUnitsTreeComponent';
